import React from 'react'
import { animateScroll as scroll } from 'react-scroll'
import { Box, IconButton, SpeedDial, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { img } from '../../imgs'

const IconSpeedDial: React.FC<{ className: any }> = ({ className }) => (
  <IconButton color="primary">
    <img src={img.upButton} alt="" className={className.iconTop} />
  </IconButton>
)

export const SpeedDialCustom: React.FC = (): JSX.Element => {
  const classes = useStyles()

  const onScrollTop = () => {
    scroll.scrollToTop()
  }

  return (
    <Box className={classes.speeddial}>
      <SpeedDial
        color="primary"
        ariaLabel="SpeedDial"
        onClick={onScrollTop}
        icon={<IconSpeedDial className={classes} />}
        sx={{ position: 'fixed', bottom: { xs: 20, md: 35 }, right: { xs: 5, md: 30 } }}
      ></SpeedDial>
    </Box>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  speeddial: {
    '& .MuiSpeedDial-fab': {
      boxShadow: 'none',
      width: 'auto!important',
      height: 'auto!important',
      backgroundColor: 'transparent',
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: 'transparent',
      },
    },
  },
  iconTop: {
    width: 80,
    height: 80,
    [down('md')]: {
      width: 65,
      height: 65,
    },
    [down('sm')]: {
      width: 55,
      height: 55,
    },
  },
}))
